import { Pipe, PipeTransform } from '@angular/core';
import { IBookingSearchResultConfig } from "../../interfaces/IConfigurableTable";
import { IsRowContainsColumnPipe } from "./is-row-contains-column.pipe";
import { ComputeColumnIndexPipe } from "./compute-column-index.pipe";
import { FindRowByIndexPipe } from "./find-row-by-index.pipe";

@Pipe({
    name: 'colspan'
})

export class ColspanPipe implements PipeTransform {

    constructor(
        private findRowByIndex: FindRowByIndexPipe,
        private isRowContainsColumn: IsRowContainsColumnPipe,
        private computeColumnIndex: ComputeColumnIndexPipe,
    ) {
    }

    public transform(rowIndex: number, column: string, config: IBookingSearchResultConfig, columnIndex: number): number {
        return this.isRowContainsColumn.transform(rowIndex, column, config) &&
            this.findRowByIndex.transform(rowIndex, config).columnStructureArray &&
            this.findRowByIndex.transform(rowIndex, config).columnStructureArray[this.computeColumnIndex.transform(columnIndex, config)]?.colWidth;
    }
}
